import { AdvancedFiltersComponentModule, AdvancedFiltersService } from '@b2b/common/components/advanced-filters';
import { PermissionsService } from '@b2b/common/services/permissions';
import { SidebarService, SidebarServiceModule } from '@b2b/common/services/sidebar';
import { TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

export const ProgramsCalendarEventControllerModule = angular
  .module('acme.view.application.programs.calendar.event.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.auth',
    'acme.common.service.calendar',
    'acme.common.service.helpers',
    SidebarServiceModule,
    'acme.common.service.userPreferences',
    'acme.common.service.permissions',
    'acme.common.directive.combobox',
    AdvancedFiltersComponentModule,
    'acme.view.application.programs.modals.createPrivateEvent.controllers',
  ])
  .controller('CalendarEventController', [
    '$scope',
    '$state',
    '$uibModal',
    'ApiService',
    'CalendarService',
    'AuthService',
    'HelpersService',
    'SidebarService',
    'CustomFieldsData',
    'PermissionsService',
    'AdvancedFiltersService',
    function (
      $scope: IScope & { calendarEvent: TODO },
      $state: StateService,
      $uibModal: UIBModalService,
      ApiService: TODO,
      CalendarService: TODO,
      AuthService: TODO,
      HelpersService: TODO,
      sidebarService: SidebarService,
      CustomFieldsData: TODO,
      PermissionsService: PermissionsService,
      advancedFiltersService: AdvancedFiltersService
    ) {
      $scope.calendarEvent = {
        events: [],
        currentView: '',
        visibleStartDate: '',
        headerDisplayDate: '',
        startTime: new Date(),
        endTime: new Date().setMonth(new Date().getMonth() + 1),
        isCSR: false,
        isLoaded: false,

        oneTimeEventDate: '',

        customFields: [],
        advancedFiltersFields: [],
        paramsCustomFields: {
          operator: 'and',
          fields: [],
        },

        searchQuery: '',

        showListType: {},
        listTypes: [
          {
            name: 'active',
            label: 'Active',
            notes: '(includes suspended events)',
          },
          {
            name: 'canceled',
            label: 'Canceled',
            notes: '',
          },
          {
            name: 'deleted',
            label: 'Deleted',
            notes: '',
          },
          {
            name: 'suspended',
            label: 'Suspended',
            notes: '',
          },
        ],

        searchEventType: {},
        eventTypes: [
          {
            name: 'all',
            label: 'All events',
          },
          {
            name: 'private',
            label: 'Partner events',
          },
          {
            name: 'offSchedule',
            label: 'Events from order requests',
          },
        ],

        searchRequestType: {},
        resourceRequestTypes: [
          {
            name: 'all',
            label: 'With/Without requests',
          },
          {
            name: 'any',
            label: 'At least one request',
          },
          {
            name: 'none',
            label: 'No requests',
          },
        ],

        privateEventModal: {},

        init: function () {
          this.oneTimeEventDate = this.getToday();

          this.isCSR = AuthService.hasPermission('CSR');

          this.showListType = this.initListType();

          $scope.$emit('Application::contentTitleChange', {
            title: 'Events List',
            buttonRight: {
              label: '+ Private Event',
              action: function () {
                $scope.calendarEvent.createPrivateEvent();
              },
              items: PermissionsService.check('EVENT_TEMPLATE_CREATE')
                ? [
                    {
                      label: '+ Create Event Template',
                      sref: 'application.templates.create.description',
                    },
                  ]
                : false,
            },
          });

          $scope.$on('calendar[event-calendar]::onTodayClick', function (e, data) {
            $state.go('application.programs.list');
          });

          $scope.$on('calendar[event-calendar]::onViewRender', function (e, data) {
            console.log('calendar[event-calendar]::onViewRender', data);
            var self = $scope.calendarEvent,
              visibleStartDate = data.view.visStart.getTime();

            if (
              !isNaN(data.view.start) &&
              !isNaN(data.view.end) &&
              (self.currentView !== data.view.name || self.visibleStartDate !== visibleStartDate)
            ) {
              self.startTime = data.view.start;
              self.endTime = data.view.end;
              self.currentView = data.view.name;
              self.visibleStartDate = visibleStartDate;
              self.headerDisplayDate = data.view.title;

              CalendarService.current.startTimeTracker = self.startTime;

              self.getEvents();
            }
          });

          if (CustomFieldsData.data && CustomFieldsData.data.success) {
            this.setCustomFields(CustomFieldsData);
          }
        },

        initListType: function () {
          var r = $scope.calendarEvent.listTypes[0]; // [0]: actives, by default

          if ($scope.calendarEvent.paramTemplateId) {
            r = $scope.calendarEvent.listTypes[1]; // [1]: deleted
          }

          return r;
        },

        createPrivateEvent: function () {
          var self = $scope.calendarEvent;

          self.privateEventModal = $uibModal.open({
            templateUrl: 'views/application/views/programs/modals/createPrivateEvent/createPrivateEvent.tpl.html',
            size: 'md',
            controller: 'CreatePrivateEventController',
            resolve: {
              startTime: function () {
                return self.startTime;
              },
            },
          });
        },

        getToday: function () {
          var date = new Date();
          date.setHours(0);
          date.setMinutes(0);
          date.setSeconds(0);
          return date;
        },

        createEventForDate: function () {
          var selectedDate = $scope.calendarEvent.oneTimeEventDate
              ? new Date($scope.calendarEvent.oneTimeEventDate)
              : new Date(),
            startTime = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 12, 0),
            endTime = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 13, 30);
          CalendarService.create({
            name: '',
            startTime: startTime,
            endTime: endTime,
          });
          $state.go('application.templates.create.description');
        },

        search: function () {
          this.isLoaded = false;
          if (this.isShowDeletedEvents()) {
            this.getDeletedEvents();
          } else {
            this.getEvents();
          }
        },

        isShowDeletedEvents: function () {
          return $scope.calendarEvent.showListType && $scope.calendarEvent.showListType.name == 'deleted';
        },

        isShowCancelledEvents: function () {
          return $scope.calendarEvent.showListType && $scope.calendarEvent.showListType.name == 'cancelled';
        },

        getCancelledEvents: function () {
          var params: TODO = {
            startTime: CalendarService.toISO8601(this.startTime),
            endTime: CalendarService.toISO8601(this.endTime),
          };

          this.isLoaded = false;

          if (this.searchQuery) {
            params.search = this.searchQuery;
          }

          $scope.calendarEvent.events.splice(0, $scope.calendarEvent.events.length);
          ApiService.event
            .cancelled(params.startTime, params.endTime, $.extend(params, HelpersService.getPaginator()))
            .then(this.success.getCancelledEvents, this.error.getCancelledEvents);
        },

        getDeletedEvents: function () {
          var params: TODO = {
            startTime: CalendarService.toISO8601(this.startTime),
            endTime: CalendarService.toISO8601(this.endTime),
          };

          this.isLoaded = false;

          if (this.searchQuery) {
            params.search = this.searchQuery;
          }

          if (this.searchRequestType.name) {
            params.requestFilter = this.searchRequestType.name;
          }

          $scope.calendarEvent.events.splice(0, $scope.calendarEvent.events.length);
          ApiService.program.trash
            .list(params, HelpersService.getPaginator())
            .then(this.success.getDeletedEvents, this.error.getDeletedEvents);
        },

        getEvents: function () {
          var params: TODO = {
            startTime: CalendarService.toISO8601(this.startTime),
            endTime: CalendarService.toISO8601(this.endTime),
          };

          this.isLoaded = false;

          if (this.searchQuery) {
            params.search = this.searchQuery;
          }

          if (this.isCSR) {
            params.saleChannel = 'customerRep';
          }

          if (this.searchRequestType.name) {
            params.resourceRequestFilter = this.searchRequestType.name;
          }
          if (this.searchEventType.name && this.searchEventType.name === 'offSchedule') {
            params.filter = this.searchEventType.name;
          }

          if (this.paramsCustomFields.fields && this.paramsCustomFields.fields.length) {
            params.customFields = this.paramsCustomFields;
          }

          switch (this.showListType.name) {
            case 'all':
              params.states = 'active,suspended,cancelled';
              break;
            case 'canceled':
              params.states = 'cancelled';
              break;
            case 'suspended':
              params.states = 'suspended';
              break;
            default:
              params.states = 'active,suspended';
              break;
          }

          console.log('CalendarEventController::getEvents', this.startTime, this.endTime);
          $scope.calendarEvent.events.splice(0, $scope.calendarEvent.events.length);
          ApiService.event.statements
            .search($.extend(params, HelpersService.getPaginator()))
            .then(this.success.getEvents, this.error.getEvents);
        },

        getResourceEvents: function (id) {
          $scope.calendarEvent.events.length = 0;

          var model = {
            ownerId: id,
            startTime: CalendarService.toISO8601(this.startTime),
            endTime: CalendarService.toISO8601(this.endTime),
          };
          ApiService.entity.schedules.owner(model).then(this.success.getResourceEvents, this.error.getResourceEvents);
        },

        setCustomFields: function (customFieldsData) {
          this.customFields = customFieldsData.data.payload.list;
          this.advancedFiltersFields = advancedFiltersService.mapCustomFieldsToAdvancedFiltersFields(this.customFields);
        },

        updateCalendarDate: function (date, mode) {
          var startDate;

          if (mode === 'month') {
            startDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
          } else if (mode === 'week') {
            startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
          } else {
            startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
          }

          $scope.$broadcast('calendarCreateEvent::update', { date: startDate });
        },

        onAdvancedFiltersClear: function () {
          var self = $scope.calendarEvent;

          self.paramsCustomFields.fields = [];
          self.paramsCustomFields.operator = 'and';
          self.getEvents();
        },

        /**
         * @param {{ rawFilters: Record<string, any>; fields: Array<any>; operator: string; }} props
         */
        onAdvancedFiltersSubmit: function (props) {
          var self = $scope.calendarEvent;

          self.paramsCustomFields.fields = props.fields;
          self.paramsCustomFields.operator = props.operator;
          self.getEvents();

          sidebarService.hide();
        },

        onAdvancedFiltersClose: function () {
          sidebarService.hide();
        },

        getEventTitle: function (event) {
          var r = event.name;
          if (event.type === 'private') {
            if (event.organization) {
              r += ' - ' + event.organization.name;
            }
          } else {
            r += ' - ' + event.scheduleName;
          }
          return r;
        },

        success: {
          getEvents: function (response) {
            var i,
              ii,
              start,
              end,
              title,
              event,
              events = response.data.payload.list,
              self = $scope.calendarEvent;

            for (i = 0, ii = events.length; i < ii; i++) {
              start = CalendarService.parseDate(events[i].startTime);
              end = CalendarService.parseDate(events[i].endTime);
              title = self.getEventTitle(events[i]);

              event = {
                id: events[i].id,
                title: title,
                eventName: events[i].name,
                scheduleName: events[i].scheduleName,
                requestSummary: events[i].requestSummary,
                start: start,
                end: end,
                allDay: (start - end) / (1000 * 60 * 60 * 24) >= 1,
              };

              if (events[i].colorCategory && events[i].colorCategory.backgroundColor) {
                event.backgroundColor = events[i].colorCategory.backgroundColor;
                event.textColor = events[i].colorCategory.textColor;
              }

              self.events.push(event);
            }

            $scope.$broadcast('calendarCreateEvent::events');
            console.log(
              'CalendarEventController::success::getEvents',
              (start - end) / (1000 * 60 * 60 * 24) >= 1,
              self.events
            );

            self.isLoaded = true;
          },

          getCancelledEvents: function (response) {
            var i,
              ii,
              start,
              end,
              event,
              events = response.data.payload.list,
              self = $scope.calendarEvent;

            for (i = 0, ii = events.length; i < ii; i++) {
              start = CalendarService.parseDate(events[i].startTime);
              end = CalendarService.parseDate(events[i].endTime);
              event = {
                id: events[i].id,
                title: events[i].name + (events[i].scheduleName ? ' - ' + events[i].scheduleName : ''),
                eventName: events[i].name,
                scheduleName: events[i].scheduleName,
                requestSummary: events[i].requestSummary,
                start: start,
                end: end,
                allDay: (start - end) / (1000 * 60 * 60 * 24) >= 1,
              };

              if (events[i].colorCategory && events[i].colorCategory.backgroundColor) {
                event.backgroundColor = events[i].colorCategory.backgroundColor;
                event.textColor = events[i].colorCategory.textColor;
              }

              self.events.push(event);
            }

            $scope.$broadcast('calendarCreateEvent::events');
            console.log(
              'CalendarEventController::success::getEvents',
              (start - end) / (1000 * 60 * 60 * 24) >= 1,
              self.events
            );

            self.isLoaded = true;
          },

          getDeletedEvents: function (response) {
            var i,
              ii,
              start,
              end,
              event,
              events = response.data.payload.list,
              self = $scope.calendarEvent;

            for (i = 0, ii = events.length; i < ii; i++) {
              start = CalendarService.parseDate(events[i].startTime);
              end = CalendarService.parseDate(events[i].endTime);
              event = {
                id: events[i].id,
                title: events[i].name + (events[i].scheduleName ? ' - ' + events[i].scheduleName : ''),
                eventName: events[i].name,
                scheduleName: events[i].scheduleName,
                requestSummary: events[i].requestSummary,
                start: start,
                end: end,
                allDay: (start - end) / (1000 * 60 * 60 * 24) >= 1,
              };

              if (events[i].colorCategory && events[i].colorCategory.backgroundColor) {
                event.backgroundColor = events[i].colorCategory.backgroundColor;
                event.textColor = events[i].colorCategory.textColor;
              }

              self.events.push(event);
            }

            $scope.$broadcast('calendarCreateEvent::events');
            console.log(
              'CalendarEventController::success::getEvents',
              (start - end) / (1000 * 60 * 60 * 24) >= 1,
              self.events
            );

            self.isLoaded = true;
          },

          getResourceEvents: function (response) {
            var i,
              ii,
              start,
              end,
              events = response.data.payload;

            for (i = 0, ii = events.length; i < ii; i++) {
              start = CalendarService.parseDate(events[i].startDateTime);
              end = CalendarService.parseDate(events[i].endDateTime);

              $scope.calendarEvent.events.push({
                id: events[i].eventId,
                title: events[i].eventName + events[i].scheduleName ? ' - ' + events[i].scheduleName : '',
                eventName: events[i].eventName,
                scheduleName: events[i].scheduleName,
                requestSummary: events[i].requestSummary,
                start: start,
                end: end,
                allDay: (start - end) / (1000 * 60 * 60 * 24) >= 1,
              });
            }

            $scope.$broadcast('calendarCreateEvent::events');
            console.log('CalendarEventController::success::getResourceEvents', $scope.calendarEvent.events);
          },
        },

        error: {
          getEvents: function (response) {
            console.log('CalendarEventController::error::getEvents', response);
          },
          getCancelledEvents: function (response) {
            console.log('CalendarEventController::error::getCancelledEvents', response);
          },
          getDeletedEvents: function (response) {
            console.log('CalendarEventController::error::getDeletedEvents', response);
          },
          getResourceEvents: function (response) {},
        },

        onEventCreated: function (e, data) {
          $scope.calendarEvent.events.push(data.event);
        },
      };

      $scope.calendarEvent.init();
    },
  ])
  .controller('CalendarEventMonthPickerController', [
    '$scope',
    '$timeout',
    'UserPreferencesService',
    function ($scope, $timeout, UserPreferencesService) {
      $scope.calendarEventMonthPicker = {
        isOpen: false,
        selectedDate: $scope.calendarEvent.startTime,

        dateOptions: {
          formatYear: 'yy',
          dateFormat: 'M!/d!/yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          showWeeks: false,
        },
        mode: 'month',
        minMode: 'month',
        maxMode: 'month',
        calendarMode: 'month',
        isPreferenceLoaded: false,

        init: function () {
          $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
          $scope.$watch('calendarEventMonthPicker.selectedDate', this.onSelectedDateUpdate);
          $timeout(function () {
            $scope.calendarEventMonthPicker.isPreferenceLoaded = true;
          }, 0);
        },

        today: function () {
          this.dt = new Date();
        },
        clear: function () {
          $scope.dt = null;
        },

        toggleMin: function () {
          $scope.minDate = $scope.minDate ? null : new Date();
        },
        open: function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          this.isOpen = true;
        },

        setCalendarDate: function () {
          $scope.calendarEvent.updateCalendarDate(this.selectedDate, this.calendarMode);
        },

        onDateFormatLoad: function (e, data) {
          var self = $scope.calendarEventMonthPicker;
          self.dateOptions = {
            formatYear: 'yy',
            dateFormat: 'M!/d!/yy',
            startingDay: UserPreferencesService.getStartDayOfWeek(),
            formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          };
        },

        onSelectedDateUpdate: function (n, o) {
          var self = $scope.calendarEventMonthPicker,
            viewType = $('#event-calendar .fc-header-right .fc-button.fc-state-active').text().toLowerCase();

          self.calendarMode = viewType;

          switch (viewType) {
            case 'month':
              self.mode = viewType;
              self.minMode = viewType;
              self.maxMode = viewType;
              break;
            case 'week':
            /* falls through */
            case 'day':
              self.mode = 'day';
              self.minMode = 'day';
              self.maxMode = 'day';
              break;
          }
          self.setCalendarDate();
        },
      };

      $scope.calendarEventMonthPicker.init();
    },
  ])
  .controller('CalendarEventDatePickerController', [
    '$scope',
    '$timeout',
    'UserPreferencesService',
    function ($scope, $timeout, UserPreferencesService) {
      $scope.calendarEventDatePicker = {
        isOpen: false,

        dateOptions: {
          formatYear: 'yy',
          dateFormat: 'M!/d!/yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          showWeeks: false,
        },
        isPreferenceLoaded: false,
        init: function () {
          $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
          $timeout(function () {
            $scope.calendarEventDatePicker.isPreferenceLoaded = true;
          }, 0);
        },

        today: function () {
          this.dt = new Date();
        },
        clear: function () {
          $scope.dt = null;
        },

        toggleMin: function () {
          $scope.minDate = $scope.minDate ? null : new Date();
        },
        open: function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          this.isOpen = true;
        },

        onDateFormatLoad: function (e, data) {
          var self = $scope.calendarEventDatePicker;
          self.dateOptions = {
            formatYear: 'yy',
            dateFormat: 'M!/d!/yy',
            startingDay: UserPreferencesService.getStartDayOfWeek(),
            formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          };
        },
      };

      $scope.calendarEventDatePicker.init();
    },
  ]).name;
